document.addEventListener('click', event => {
  if( event.target.classList.contains('js-load-more') ) {
    fetch_posts(event);
  }
});

function fetch_posts(event) {

  console.log(event.target);
  event.preventDefault();

  const parent = event.target.closest('section');
  const wrapper = parent.querySelector('.section_posts');
  const loader = document.querySelector('.js-loader');
  const nonce = document.querySelector('#more_posts_nonce');

  console.log(wrapper);

  if( ! ( loader.classList.contains('is-loading') || loader.classList.contains('no-posts') ) ) {
    const data = new FormData();

    data.append('morePostsNonce', nonce.value);
    data.append('action', eg_zoo_fetch_localization.action);

    loader.classList.add('is-loading');

    fetch(eg_zoo_fetch_localization.fetchurl, {
      method: 'POST',
      body: data
    })
      .then(response => response.json())
      .then(response => {
        const contents = response.data;

        if( contents.length ) {
          console.log(wrapper.innerHTML);
          wrapper.innerHTML = wrapper.innerHTML + contents;
          loader.classList.remove('is-loading');
        } else {
          button.innerHTML = eg_zoo_fetch_localization.noPosts;
          loader.classList.remove('is-loading');
          loader.classList.add('no-posts');
        }
      })
      .catch(error => {
        console.error('Error:', error);
      });
  }
}
